import React from 'react';

import './styles.scss';

const SecurityPolicy = () => {
  const plataforma = 'Plataforma Camil';

  return (
    <div className="security-policy">
      <div className="policy-title">Política de Segurança</div>

      <div className="policy-content">
        <p>
          Nós levamos a segurança da
          <strong> {plataforma}</strong> muito a sério. Se você acredita ter
          encontrado uma vulnerabilidade em nosso sistema, nós te encorajamos a
          nos notificar imediatamente para que possamos investigar e corrigir o
          problema o mais rápido possível.
        </p>

        <div className="policy-subtitle">
          <h2>Como Reportar uma Vulnerabilidade</h2>
          <p>
            Por favor, envie um e-mail com a descrição detalhada da
            vulnerabilidade para:
          </p>
        </div>

        <div className="contact-info">
          <p className="">
            <a href="mailto:equipeti@multimaxi.com.br">
              equipeti@multimaxi.com.br
            </a>
          </p>
        </div>

        <div className="policy-report">
          <p>Inclua as seguintes informações no seu e-mail, se possível:</p>
          <ul>
            <li>
              <strong>Descrição:</strong> Detalhe a vulnerabilidade e o que ela
              permite que um invasor faça.
            </li>
            <li>
              <strong>Passos para Reproduzir:</strong> Forneça os passos exatos
              ou um script para que a nossa equipe possa reproduzir a
              vulnerabilidade.
            </li>
            <li>
              <strong>Impacto Potencial:</strong> Explique o impacto que a
              vulnerabilidade poderia ter.
            </li>
          </ul>
        </div>

        <div className="policy-info">
          <h2>Nossas Expectativas</h2>
          <ul>
            <li>
              <strong>Não Divulgue a Falha Publicamente:</strong> Por favor, não
              divulgue a vulnerabilidade publicamente até que tenhamos tido
              tempo suficiente para investigá-la e corrigi-la.
            </li>
            <li>
              <strong>Teste com Cuidado:</strong> Não explore a vulnerabilidade
              além do necessário para provar sua existência. Evite acessar ou
              modificar dados que não pertencem a você.
            </li>
          </ul>
        </div>

        <p className="acknowledgement">
          Agradecemos a sua ajuda em manter nosso sistema seguro.
        </p>
      </div>
    </div>
  );
};

export default SecurityPolicy;
